<template>
    <delivery
        v-if="!!order.productPrice"
        :prop-payment-type="order.paymentType"
        :prop-product-name="order.productName"
        :prop-product-price="order.productPrice"
        :prop-copyright="order.copyright"
        :prop-tree="order.tree"
    />
</template>

<script>
import Delivery from "./Delivery.vue";
import Vue from "vue";

export default {
    name: "DeliveryExternalAppeal",
    components: {
        Delivery
    },
    data() {
        return {
            order: {
                paymentType: window.laravel.paymentTypes.page,
                productName: null,
                productPrice: null,
                copyright: false,
                tree: null
            },
        }
    },
    mounted() {
        this.order.copyright = Object(this.$route.query).hasOwnProperty('copyright')
            && parseInt(this.$route.query.copyright) === 1;

        this.order.productPrice = parseFloat(String(this.$route.query.price));

        this.order.tree = Object(this.$route.query).hasOwnProperty('tree') ? this.$route.query.tree : null;

        this.order.productName = Vue.prototype.$lang(
            this.order.copyright
                ? 'user.pages.itemName2'
                : 'user.pagesBlock.productNameFull'
        );
    },
    destroyed() {
        this.$router.push({name: 'cabinet'});
    }
}
</script>
